module.exports = __webpack_public_path__ + "img/help2.451d47a9.jpg";